import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {Typography} from "@/shared/ui/data-display/typography";

import "./styles/info-card-wide.scss";

export interface InfoCardWideProps {
    id: number;
    image: InfoCardWideImageProps;
    title: string;
    description?: string;
    button?: {
        text: string;
        url: string;
        target?: "_self" | "_blank";
    };
}

interface InfoCardWideImageProps {
    src: string;
    alt: string;
    width?: number;
    height?: number;
}

export function InfoCardWide({image, title, description, button}: InfoCardWideProps): JSX.Element {
    const imageWidth = image.width ?? 704;
    const imageHeight = image.height ?? 340;

    const buttonText = button?.text || "Read more";
    const buttonUrl = button?.url || "#";
    const buttonTarget = button?.target || "_self";

    return (
        <article className="info-card-wide">
            <Link href={buttonUrl} className="info-card-wide__image" aria-label={title} target={buttonTarget}>
                <SmartImage src={image.src} alt={image.alt} width={imageWidth} height={imageHeight} />
            </Link>
            <div className="info-card-wide__content">
                <div className="info-card-wide__content-text">
                    <Typography as="h3" weight={600} size={{desktop: 14, mobile: 10}} className="info-card-wide__title" lineHeight={120}>
                        {title}
                    </Typography>
                    <Typography as="p" lineHeight={120} size={10} weight={400} color="paragraph" className="info-card-wide__description">
                        {description}
                    </Typography>
                </div>
                <ButtonBase
                    as="link"
                    href={buttonUrl}
                    weight="semibold"
                    variant="primary"
                    size="sm"
                    className="info-card-wide__button"
                    target={buttonTarget}
                >
                    {buttonText}
                </ButtonBase>
            </div>
        </article>
    );
}
